import React from 'react';
import './DarkCard.scss';

const SuccessCard = ({title, subtitle, stats, icon, trend, statsicon}) => {
  console.log("trend", trend);

  return (
    <React.Fragment>
      <div className={`${trend == "up" ? "bg-[#35c759]" : trend === "down" ? "bg-[#ff373c]" : "border"} flex w-full flex-1 px-2 py-2 min-h-24 justify-start items-center rounded-md dark-bg`}>
       <span className='flex justify-start items-start'>
          {/* <div className={`${trend == "up" ? "bg-green-200" : trend === "down" ? "bg-red-200" : ""} me-2 w-10 h-10 flex justify-center items-center rounded-full text-2xl flex-shrink-0`}>
            {icon && icon}
          </div> */}
          <span>
            <div className={`${trend == "up" ? "text-up-trend" : trend === "down" ? "text-down-trend" : "state-card-text"} mb-1 text-[1.3rem] leading-[1.2] font-bold`}>
              {statsicon && statsicon} {stats && stats}
            </div>
            <p className={`text-sm font-bold  ${title == "Improved Area"  ?  "mb-2" : "mb-4"} ${trend == "up" || trend === "down" ?  " text-white" : "state-card-text"}` }>{title && title}</p>
            <p className={`mb-0 text-xs ${trend == "up" || trend === "down" ? " text-white" : "state-card-text"}`}>{subtitle && subtitle}</p>
          </span>
        </span>
      </div>
    </React.Fragment>
  );
}

export default SuccessCard;
